import { CardContent, Stack, Switch, Tooltip, Typography } from '@mui/material';

import { Icon } from '@/components/shared/icon';

export const StartInstanceAfterRestoreToggle = ({
  checked,
  onChange,
  disabled,
  switchWrapper,
}: {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  switchWrapper?: (switchElement: React.ReactElement) => React.ReactNode;
}) => {
  const switchEl = (
    <Switch
      disabled={disabled}
      size='small'
      checked={checked}
      onChange={onChange}
    />
  );

  return (
    <CardContent className='px-[40px]'>
      <Stack
        className='group/startInstanceAfterRestore'
        direction='row'
        alignItems='center'
        justifyContent='space-between'
      >
        <Typography className='font-semibold' variant='body1'>
          Start instance after restore
        </Typography>
        <Stack direction='row' alignItems='center' gap='8px'>
          <Tooltip title='When enabled, Eon will start the restored instance automatically. Turn off to leave it in a stopped state.'>
            <Icon
              className='opacity-0 group-hover/startInstanceAfterRestore:opacity-100 transition-opacity'
              iconClass='material-symbols-help-outline-rounded'
            />
          </Tooltip>
          {switchWrapper ? switchWrapper(switchEl) : switchEl}
        </Stack>
      </Stack>
    </CardContent>
  );
};
